import { useEffect, useRef } from 'react';

import type { CalendarAppointmentEvent } from 'components/mrp/components/Calendar/Calendar.types';
import type { CalendarPosition } from '../CalendarNavigationHandler.types';

type UsePendingEventRestoreParams = {
  appointmentId: string | number | undefined;
  calendarEvents: { [calendarId: string]: CalendarAppointmentEvent[] };
  position: CalendarPosition | undefined;
};

export const usePendingEventRestore = ({
  appointmentId,
  calendarEvents,
  position
}: UsePendingEventRestoreParams) => {
  'use memo';
  const pendingRestoreEventId = useRef<string | number | undefined>(undefined);
  const pendingRestoreOriginalAppointmentId = useRef<
    string | number | undefined
  >(undefined);

  useEffect(() => {
    if (appointmentId && pendingRestoreEventId.current === undefined) {
      pendingRestoreEventId.current = appointmentId;
      pendingRestoreOriginalAppointmentId.current = calendarEvents[
        position?.calendarId || -1
      ]?.find((e) => e.id === appointmentId)?.planningEvent
        ?.originalAppointmentId;
    }
  }, [appointmentId, calendarEvents, position?.calendarId]);

  return {
    pendingRestoreEventId,
    pendingRestoreOriginalAppointmentId,
    clearPendingRestore: () => {
      pendingRestoreEventId.current = undefined;
      pendingRestoreOriginalAppointmentId.current = undefined;
    }
  };
};
